import PropTypes from "prop-types";
import React from "react";
import TableHeader from "./Table.Header";
import { SortDirection } from "../../constants";

export default class Table extends React.Component {

    static displayName = "Table";

    static get Header() {
        return TableHeader;
    }

    static defaultPropTypes = {
        sortDirection: SortDirection.ASC
    };

    static propTypes = {
        columnGroup: PropTypes.element,
        currSortKey: PropTypes.string,
        headerGroups: PropTypes.node,
        headers: PropTypes.array,
        onSort: PropTypes.func,
        sortDirection: PropTypes.oneOf(Object.values(SortDirection)),
    };

    get className() {
        return this.props.className
    }

    handleSort = (sortKey) => {
        const { currSortKey, onSort } = this.props;
        const toggledSortDir = sortKey === currSortKey;

        if (onSort) {
            const isDescending = toggledSortDir ? !this.isDescendingSort : false;
            onSort(sortKey, isDescending);
        }

    };

    get isDescendingSort() {
        return this.props.sortDirection === SortDirection.DESC;
    };

    get hasHeaders() {
      const { headers } = this.props;
      return Boolean(headers && headers.length);
    };

    get headers() {
        const { currSortKey, headers, sortDirection } = this.props;
        return headers.map(header => {
            if (header.props.sortKey) {
                // manage table headers by injecting props
                return React.cloneElement(header, {
                    ...header.props,
                    _isCurrentSortHeader: header.props.sortKey === currSortKey,
                    _onSort: this.handleSort,
                    _sortDirection: sortDirection,
                });
            }
            return header;
        });
    };

    get headerGroups() {
        const { headerGroups } = this.props;
        return headerGroups ? <tr>{headerGroups}</tr> : null;
    };

    get tableHeader() {
        return this.hasHeaders ? (
            <thead>
                {this.headerGroups}
                <tr>
                    {this.headers}
                </tr>
            </thead>
        ) : null;
    };

    render() {
        return (
            <table {...this.extraProps} className={this.className}>
                {this.props.columnGroup}
                {this.tableHeader}
                <tbody>
                {this.props.children}
                </tbody>
            </table>
        );
    }
}
